import { createApiAction } from '@saucelabs/sl-util-redux';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import { getFilterParamsAdapter, getTimeFilterParams } from './../../api-adapter';
import * as api from './api';
import * as types from './types';
import * as actions from './actions';
import * as selectors from './selectors';
import { LOAD_INIT_DATA } from './../general/types';
import { META_SKIP_ERROR_PAGE } from '../../constants';
import { getFilters } from './../filters/operations';

// get test names
export const getTestNames = createApiAction(
  types.GET_TEST_NAMES,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
      ...getFilterParamsAdapter(
        analytics.filters.get('filters').filter((value, key) => key === 'owners'),
      ),
      size: 100,
      ...payload,
    };

    return api.getTestNames(params);
  },
);

// get test metrics
export const getTestMetrics = createApiAction(
  types.GET_TEST_METRICS,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
      ...payload,
    };

    return api.getTestMetrics(params);
  },
);

export const getPreviousTestMetrics = createApiAction(
  types.GET_PREVIOUS_TEST_METRICS,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(
        analytics.filters.get('selectedDateFilter'),
        Date.now() - (analytics.filters.getIn(['selectedDateFilter', 'value']) * 1000),
      ),
      ...payload,
    };

    return api.getTestMetrics(params);
  },
);

// get tests
export const getTests = createApiAction(
  types.GET_TESTS,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
      size: 100,
      from: 0,
      ...payload,
    };
    return api.getTests(params, meta);
  },
);

export const loadInitData = createApiAction(
  LOAD_INIT_DATA,
  (payload, meta, dispatch) => Promise.all([
    dispatch(getFilters()),
    dispatch(getTestNames(payload)),
  ]),
);

export const getTestHistory = (payload, meta = META_SKIP_ERROR_PAGE) => (dispatch, getState) => (
  dispatch(actions.getTestHistory(
    selectors.testHistoryParamsSelector(getState(), payload),
    meta,
  )).catch((error) => {
    dispatch(
      notificationActions.notifyDanger(error.message, 'Fetching test history failed!'),
    );
  })
);

export const getTestsInGroup = (payload, meta = META_SKIP_ERROR_PAGE) => (dispatch, getState) => {
  dispatch(actions.selectTestGroup(payload));

  return dispatch(actions.getTestsInGroup(
    selectors.testsInGroupParamsSelector(getState(), payload),
    meta,
  )).catch((error) => {
    dispatch(
      notificationActions.notifyDanger(error.message, 'Fetching tests failed!'),
    );
  });
};

export const clearTestsInGroup = () => (dispatch) => Promise.all([
  dispatch(actions.deselectTestGroup()),
  dispatch(actions.clearTestsInGroup()),
]);
